module.exports = __webpack_public_path__ + "static/media/blueCabinet.95f1a1d8.svg";